export default __webpack_public_path__ + "static/media/Telengana_Hover.634fc909.svg";